<template>
    <div id="wallet">
        <!-- <div class="top_title fixed">我的钱包</div> -->
        <div class="safe-area">
            <div class="cont">
                <img class="safe_icon" src="../../assets/bx/safe.png" alt="">
                <span>资金安全有保障</span>
            </div>
            <div class="bottom_radius"></div>
        </div>
        <div class="box_item">
            <div class="wallet_box">
                <div class="ye_1">
                    <span>余额（元）</span>
                    <img class="eyes" :src="showWallet?eyesopen:eyesclose" alt="" @click="changeEyes">
                </div>
                <div class="ye_2" v-if="!showWallet">
                    <img class="xing" src="../../assets/bx/xing.png" alt="" v-for="(item,i) in 8" :key="i">
                </div>
                <div class="ye_2" v-else>
                   {{ userData.balance }}
                </div>
            </div>
            <div class="serve_boxes">
                <div class="serve_box" v-for="(item,i) in serve_box" :key="i" @click="gotoTarget(item.path)">
                    <img :src="item.icon" alt="">
                    <div class="txt">{{ item.text }}</div>
                </div>
            </div>
        </div>
        <div class="box_item">
            <div class="wallet_box">
                <div class="ye_1">
                    <span>保证金（元）</span>
                    <img class="eyes" :src="showWallet2?eyesopen:eyesclose" alt="" @click="changeEyes2">
                </div>
                <div class="ye_2" v-if="!showWallet2">
                    <img class="xing" src="../../assets/bx/xing.png" alt="" v-for="(item,i) in 8" :key="i">
                </div>
                <div class="ye_2" v-else>
                   {{ userData.margin }}
                </div>
            </div>
            <div class="serve_boxes">
                <div class="serve_box" v-for="(item,i) in margin_box" :key="i" @click="gotoTarget(item.path)">
                    <img :src="item.icon" alt="">
                    <div class="txt">{{ item.text }}</div>
                </div>
            </div>
        </div>
        <div class="box" @click="gotoTarget(manage.path)">
            <img :src="manage.icon" alt="">
            {{ manage.text }}
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            eyesclose: require('../../assets/bx/eyes_close.png'),
            eyesopen: require('../../assets/bx/eyes_open.png'),
            showWallet: false,
            showWallet2: false,
            serve_box: [
                {
                    icon: require('../../assets/bx/acc/w1.png'),
                    text: '余额提现',
                    path: 'user.withdraw'
                },
                // {
                //     icon: require('../../assets/bx/acc/w2.png'),
                //     text: '我要充值',
                //     path: 'user.recharge'
                // },

                {
                    icon: require('../../assets/bx/acc/w3.png'),
                    text: '账务明细',
                    path: 'account.detail'
                },
            ],
            margin_box: [
                {
                    icon: require('../../assets/bx/acc/w1.png'),
                    text: '余额提现',
                    path: 'margin.withdraw'
                },
                // {
                //     icon: require('../../assets/bx/acc/w2.png'),
                //     text: '我要充值',
                //     path: 'margin.recharge'
                // },

                {
                    icon: require('../../assets/bx/acc/w3.png'),
                    text: '账务明细',
                    path: 'margin.detail'
                },
            ],
            manage: {
                icon: require('../../assets/bx/serve_03.png'),
                text: '我的提现账号',
                path: 'account.manage'
            },
        }
    },
    computed: {
        userData() {
            return this.$store.getters.state.userData || {};
        },
        isVerify() {
            return this.$store.getters.isVerify;
        },
    },
    mounted() {

    },
    methods: {
        changeEyes() {
            this.showWallet = !this.showWallet
        },
        changeEyes2() {
            this.showWallet2 = !this.showWallet2
        },
        gotoTarget(name) {
            if(!this.isVerify) {
                if(name == 'user.withdraw' || name == 'margin.withdraw') {
                    this.$toast({
                        message: '请先完成实名认证',
                        duration: "2000",
                        onClose: () => {
                            this.$router.replace({
                                name: "user.identity",
                            });
                        },
                    });
                    return;
                }else {
                    this.$router.push({name})
                }
            }else {
                this.$router.push({name})
            }
        }
    },
}
</script>
<style lang="less" scoped>
    #wallet {
        .safe-area {
            height: 3.6rem;
            background-color: var(--themebgc);
            // border-top-left-radius: 1rem;
            // border-top-right-radius: 1rem;
            margin-bottom: 1rem;
            position: relative;
            .cont {
                height: 80%;
                display: flex;
                justify-content: center;
                align-items: center;
                color: var(--theme);
                padding-top: 0.3rem;
                .safe_icon {
                    width: 1.1rem;
                    height: 1.3rem;
                    display: inline-block;
                    vertical-align: baseline;
                    margin-top: 0.1rem;
                    margin-right: 0.2rem;
                }
            }
            .bottom_radius {
                position: absolute;
                bottom: -0.5rem;
                left: 0;
                width: 100%;
                height: 1rem;
                border-top-left-radius: .5rem;
                border-top-right-radius: .5rem;
                background-color: var(--innerbgc);
            }
        }
        .wallet_box {
            padding: 2rem 1.2rem 0;
            margin-bottom: 1.2rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 2.3rem;
                width: .2rem;
                height: 1.3rem;
                background-color: var(--theme);
                border-radius: .2rem;
            }
            .ye_1 {
                color: #000;
                font-size: 1.4rem;
                font-weight: 700;
                .eyes {
                    width: 1.65rem;
                    height: .95rem;
                    margin-left: 0.3rem;
                    cursor: pointer;
                }
            }
            .ye_2 {
                height: 1.85rem;
                font-size: 1.8rem;
                font-weight: 700;
                color: var(--red);
                display: flex;
                align-items: center;
                .xing {
                    width: 1.1rem;
                    height: 1rem;
                    margin: 0 0.1rem;
                }
            }
        }
        .serve_boxes {
            display: flex;
            justify-content: flex-start;
            .serve_box {
                width: calc(1/3*100%);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                padding: 1.4rem 0 2rem;
                font-size: 1.2rem;
                color: #000;
                img {
                    width: 2.4rem;
                    height: 2.4rem;
                    margin-bottom: .45rem;
                }
                &:hover {
                    .txt {
                        color: var(--theme);
                    }
                }
            }
        }
        .box_item {
            background-color: #fff;
            border-radius: 1rem;
            margin: 0 1rem 1rem;
        }
    }
    .box {
        margin: 0 1rem;
        background-color: #fff;
        border-radius: 1rem;
        padding: 1rem;
        font-size: 1.4rem;
        color: #000;
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
            width: 2.4rem;
            height: 2.6rem;
            margin-right: 0.5rem;
        }
    }
</style>